const BASE_URL = "/ledger";


export default [
  {
    path: `${BASE_URL}/`,
    name: "Ledger",
    component: () => import("@/pages/generalLedger/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-journal`,
    name: "General Journal",
    component: () => import("@/pages/generalLedger/generalJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/setup`,
    name: "General Ledger Setup",
    component: () => import("@/pages/generalLedger/generalLedgerSetup/Index.vue"),
  },
  {
    path: `${BASE_URL}/account-reconciliation-journal`,
    name: "Account Reconciliation Journal",
    component: () => import("@/pages/generalLedger/accountReconciliationJournal/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-journal-master-template`,
    name: "General Journal Master Template",
    component: () => import("@/pages/generalLedger/generalJournalMasterTemplate/Index.vue"),
  },
  {
    path: `${BASE_URL}/general-ledger-entry-changes-log`,
    name: "General Ledger Entry Changes Logs",
    component: () => import("@/pages/generalLedger/changesLogs/GeneralLedgerEntryChangesLogs.vue"),
  },
];
